export enum Slot {
  Driver = 0,
  CoDriver = 1,
  Both = 2,
}
